import { ROLES } from "../../config/roles";
import { ROUTE_TYPES } from "../../config/routeTypes";

import * as Pages from "../../pages";

const routes = [
  // Root
  {
    path: "/",
    exact: true,
    name: "Home",
    element: Pages.Home,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },
  {
    path: "/hello-world",
    exact: true,
    name: "Hello World",
    element: Pages.HelloWorld,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },

  // Auth
  {
    path: "/login",
    exact: true,
    name: "Login",
    element: Pages.P_Login,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },
  {
    path: "/signup",
    exact: true,
    name: "Signup",
    element: Pages.P_Signup,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },

  // Contact
  {
    path: "/contact",
    exact: true,
    name: "Contact",
    element: Pages.P_Contact,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },

  //   Content
  {
    path: "/content/medium",
    exact: true,
    name: "Medium",
    element: Pages.P_Medium,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },
  {
    path: "/content/youtube",
    exact: true,
    name: "YouTube",
    element: Pages.P_YouTube,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },
  {
    path: "/content/workshops",
    exact: true,
    name: "Workshops",
    element: Pages.P_Workshops,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },

  //   Education
  {
    path: "/education/academics",
    exact: true,
    name: "Academics",
    element: Pages.P_Academics,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },
  {
    path: "/education/certifications",
    exact: true,
    name: "Certifications",
    element: Pages.P_Certifications,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },

  // Experience
  {
    path: "/experience",
    exact: true,
    name: "Experience",
    element: Pages.P_Experience,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },

  // Lifestyle
  {
    path: "/lifestyle",
    exact: true,
    name: "Lifestyle",
    element: Pages.P_Lifestyle,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },

  //   Education
  {
    path: "/projects/game",
    exact: true,
    name: "Game",
    element: Pages.P_Game,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },
  {
    path: "/projects/software",
    exact: true,
    name: "Software",
    element: Pages.P_Software,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },

  // Research
  {
    path: "/research",
    exact: true,
    name: "Research",
    element: Pages.P_Research,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },
];

export default routes;
